import { withStyles } from '@material-ui/core';

import EmailField from './component';
import styles from './styles';

export default withStyles(styles)(EmailField);
